export const ADMIN_DEPARTMENT_NAME = 'Admin';
export const ADMIN_POSITION_NAME = 'Admin';

export const DEPARTMENT_HIDDEN_TYPE_REQUEST = 'REQUEST';
export const DEPARTMENT_HIDDEN_TYPE_COMMUNICATION = 'COMMUNICATION';
